import React from 'react'
import { autoResize } from 'src/lib/utils'
import ErrorMessage from './ErrorMessage'
import PropTypes from 'prop-types'
import { Field, getIn } from 'formik'

export default function TextareaFieldWrapper({ formik, label, name, className, isNoDisplayError }) {
  const { touched, errors } = formik
  return (
    <div className={`form-group ${className}`}>
      {label && <label>{label}</label>}

      <Field
        as="textarea"
        className={`form-control ${getIn(touched, name) && getIn(errors, name) ? 'is-invalid' : ''}`}
        name={name}
        rows={2}
        style={{ overflowY: 'hidden' }}
        innerRef={(textAreaRef) => autoResize(textAreaRef)}
      />
      {!isNoDisplayError && <ErrorMessage name={name} formik={formik} className="bg-transparent" />}
    </div>
  )
}

TextareaFieldWrapper.propTypes = {
  formik: PropTypes.object,
  label: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  isNoDisplayError: PropTypes.bool,
}

TextareaFieldWrapper.defaultProps = {
  label: '',
}
